import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const SettingsContext = createContext();

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState({
        company_name: 'Rudraksh 925',
        tagline: 'Luxury Silver & Gold Jewellery',
        address: '',
        contact_number: '',
        email: '',
        gstin: '',
        hsn_code: '7113',
        currency: 'INR',
        currency_symbol: '₹',
        default_cgst: 1.5,
        default_sgst: 1.5,
        default_tcs_tds: 0.0,
        sale_paper_size: 'custom',
        sale_page_format: 'l',
        sale_items_per_page: 8,
        sale_page_width: 210,
        sale_page_height: 148,
        shortcuts: {
            save: { key: 's', ctrlKey: true },
            new_sale: { key: 'n', ctrlKey: true },
            new_item: { key: 'i', ctrlKey: true },
            search: { key: 'f', ctrlKey: true }
        }
    });
    const [loading, setLoading] = useState(true);

    const fetchSettings = useCallback(async () => {
        try {
            const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
            const response = await axios.get(`${BACKEND_URL}/api/settings`);
            setSettings(response.data);
        } catch (error) {
            console.error('Failed to fetch global settings:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSettings();
        
        // Listen for internal settings updates
        const handleSettingsUpdate = () => {
            fetchSettings();
        };
        window.addEventListener('settingsUpdated', handleSettingsUpdate);
        return () => window.removeEventListener('settingsUpdated', handleSettingsUpdate);
    }, [fetchSettings]);

    return (
        <SettingsContext.Provider value={{ settings, loading, refreshSettings: fetchSettings }}>
            {children}
        </SettingsContext.Provider>
    );
};
